"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = exports.TooltipSize = void 0;
const react_1 = __importStar(require("react"));
const react_2 = require("@headlessui/react");
const clsx_1 = __importDefault(require("clsx"));
const Text_1 = require("../Text");
var TooltipSize;
(function (TooltipSize) {
    TooltipSize["XS"] = "w-[80px]";
    TooltipSize["SM"] = "w-[120px]";
    TooltipSize["MD"] = "w-[160px]";
    TooltipSize["LG"] = "w-[220px]";
})(TooltipSize = exports.TooltipSize || (exports.TooltipSize = {}));
function Tooltip({ testId, content, size, children }) {
    const buttonRef = (0, react_1.useRef)(null);
    const timeoutDuration = 200;
    let timeout;
    const closePopover = () => {
        var _a;
        return (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new KeyboardEvent('keydown', {
            key: 'Escape',
            bubbles: true,
            cancelable: true,
        }));
    };
    const onMouseEnter = (open) => {
        var _a;
        clearTimeout(timeout);
        if (open)
            return;
        return (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    const onMouseLeave = (open) => {
        if (!open)
            return;
        timeout = setTimeout(() => closePopover(), timeoutDuration);
    };
    return (react_1.default.createElement("div", { "data-testid": testId },
        react_1.default.createElement(react_2.Popover, { className: "relative" }, ({ open }) => (react_1.default.createElement("div", null,
            react_1.default.createElement(react_2.Popover.Button, { className: "outline-0", ref: buttonRef, onMouseEnter: onMouseEnter.bind(null, open), onMouseLeave: onMouseLeave.bind(null, open) }, children),
            react_1.default.createElement(react_2.Transition, { as: react_1.Fragment, enter: "transition ease-out duration-500", enterFrom: "opacity-0 translate-y-1", enterTo: "opacity-100 translate-y-0", leave: "transition ease-in duration-450", leaveFrom: "opacity-100 translate-y-0", leaveTo: "opacity-0 translate-y-1" },
                react_1.default.createElement(react_2.Popover.Panel, { className: (0, clsx_1.default)('absolute z-10 bg-white px-4 py-2 rounded-lozenge', size) },
                    react_1.default.createElement(Text_1.Text, { type: Text_1.TextType.BODY_S, className: "text-black text-center" }, content))))))));
}
exports.Tooltip = Tooltip;
//# sourceMappingURL=Tooltip.js.map